import { render, staticRenderFns } from "./answer-details.vue?vue&type=template&id=9128f34a&scoped=true&"
import script from "./answer-details.vue?vue&type=script&lang=js&"
export * from "./answer-details.vue?vue&type=script&lang=js&"
import style0 from "./answer-details.vue?vue&type=style&index=0&id=9128f34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9128f34a",
  null
  
)

export default component.exports